import {
  addFooterSignature,
  waitForInstagramBtn,
  addInstagramBlock,
} from "../modules/footer.js";

function isPageType(pageTypes) {
  const pageType = window.dataLayer?.[0]?.shoptet?.pageType;
  return pageTypes.includes(pageType);
}

addFooterSignature();

// ! Extended menu

async function handleCategoryImage() {
  const menuLists = document.querySelectorAll(".navigation-in ul.menu-level-2");

  menuLists.forEach((ul) => {
    if (ul.querySelector(".menu-level-2-wrapper")) {
      return;
    }

    const wrapperDiv = document.createElement("div");
    wrapperDiv.className = "menu-level-2-wrapper";

    while (ul.firstChild) {
      wrapperDiv.appendChild(ul.firstChild);
    }

    ul.appendChild(wrapperDiv);
  });

  const menuItems = document.querySelectorAll(".menu-level-1 > li");

  for (const menuItem of menuItems) {
    const submenuWrapper = menuItem.querySelector(".menu-level-2-wrapper");
    if (!submenuWrapper) {
      continue;
    }

    if (
      submenuWrapper.nextElementSibling?.classList.contains(
        "custom-category-image"
      )
    ) {
      continue;
    }

    const link = menuItem.querySelector("a");
    if (!link || !link.href) {
      continue;
    }

    try {
      const response = await fetch(link.href);
      if (!response.ok) {
        continue;
      }

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const categoryImage = doc.querySelector(".category-perex img");

      if (categoryImage && categoryImage.src) {
        const img = document.createElement("img");
        img.src = categoryImage.src;
        img.alt = categoryImage.alt || "";
        img.classList.add("custom-category-image");
        img.style.marginBottom = "10px";

        submenuWrapper.insertAdjacentElement("afterend", img);
      }
    } catch (error) {
      console.error("Error loading category image:", error);
    }
  }
}

document.addEventListener("DOMContentLoaded", handleCategoryImage);
document.addEventListener("ShoptetDOMContentLoaded", handleCategoryImage);
document.addEventListener("ShoptetPageSortingChanged", handleCategoryImage);
// ! Main page

function addContactInfo(footer) {
  const cartProjectMail = document.querySelector(".contact-box .mail");
  const cartProjectPhone = document.querySelector(".contact-box .tel");

  const phoneWrapper = footer?.querySelector(".phone-wrapper");
  if (cartProjectPhone && phoneWrapper) {
    const phoneClone = cartProjectPhone.cloneNode(true);
    phoneClone.classList.add("project-phone");
    phoneWrapper.prepend(phoneClone);
  }

  const mailWrapper = footer?.querySelector(".mail-wrapper");
  if (cartProjectMail && mailWrapper) {
    const mailClone = cartProjectMail.cloneNode(true);
    mailClone.classList.add("project-mail");
    mailWrapper.prepend(mailClone);
  }
}

function moveSiteLogoToFooter() {
  const siteLogoDiv = document.querySelector(".footer-rows .site-name");
  const footerCustomElementsDiv = document.querySelector(
    ".custom-footer__contact"
  );

  const footerLinks = document.querySelector(".footer-links-icons");

  if (siteLogoDiv && footerCustomElementsDiv) {
    siteLogoDiv.append(footerCustomElementsDiv);
  }

  if (footerLinks) {
    siteLogoDiv.append(footerLinks);
  }
}

moveSiteLogoToFooter();

const swiper = new Swiper(".swiper-brands", {
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 6,
  spaceBetween: 24,
  breakpoints: {
    0: { slidesPerView: 2.8, spaceBetween: 8 },
    768: { slidesPerView: 3 },
    1024: { slidesPerView: 4 },
    1240: { slidesPerView: 6 },
  },
});

function createTitleButton(titleText, buttonLabel, buttonLink) {
  const titleDiv = document.createElement("div");
  titleDiv.classList.add("title-button");

  titleDiv.innerHTML = `
    <h4>${titleText}</h4>
    <a class="btn btn-primary" href="${buttonLink}">${buttonLabel}</a>
  `;

  return titleDiv;
}

const footerGlobal = document.querySelector("#footer");

// ! Reviews
async function handleReviews() {
  try {
    const response = await fetch("/hodnoceni-obchodu");
    const text = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    const allReviews = doc.querySelectorAll(
      '.vote-wrap[data-testid="gridRating"]'
    );

    const filteredReviews = Array.from(allReviews)
      .filter((review) => {
        const content = review.querySelector(".vote-content");
        return content && content.textContent.trim().length > 0;
      })
      .slice(0, 5);

    if (filteredReviews.length === 0) return;

    let reviewsContainer = document.querySelector(".review-container");
    if (!reviewsContainer) {
      reviewsContainer = document.createElement("div");
      reviewsContainer.classList.add("review-container", "container");

      const footer = document.querySelector("#footer");
      if (footer) {
        footer.insertAdjacentElement("beforebegin", reviewsContainer);
      } else {
        console.error("Footer not found");
      }
    } else {
      console.log("Reviews container already exists");
    }

    const heading = document.createElement("h4");
    heading.textContent = "Co o nás říkáte?";
    reviewsContainer.appendChild(heading);

    // Swiper structure
    const swiperContainer = document.createElement("div");
    swiperContainer.classList.add("swiper-container", "review-swiper");

    const prevBtn = document.createElement("div");
    prevBtn.className = "swiper-button-prev";

    const nextBtn = document.createElement("div");
    nextBtn.className = "swiper-button-next";

    const swiper = document.createElement("div");
    swiper.className = "swiper";

    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    for (const review of filteredReviews) {
      const stars = review.querySelector('[data-testid="gridStars"]');
      const text = review.querySelector('[data-testid="textRating"]');
      const name = review.querySelector('[data-testid="textRatingAuthor"]');
      const date = review.querySelector(
        '[data-testid="latestContributionDate"]'
      );

      if (!stars || !text || !name || !date) continue;

      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");

      slide.appendChild(stars.cloneNode(true));

      const textEl = document.createElement("div");
      textEl.className = "vote-content";
      textEl.textContent = text.textContent.trim();
      slide.appendChild(textEl);

      const footerEl = document.createElement("div");
      footerEl.className = "vote-footer";
      footerEl.innerHTML = `${name.textContent.trim()} <span>${date.textContent.trim()}</span>`;
      slide.appendChild(footerEl);

      wrapper.appendChild(slide);
    }

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";

    swiper.appendChild(wrapper);
    swiper.appendChild(pagination);

    swiperContainer.appendChild(prevBtn);
    swiperContainer.appendChild(nextBtn);
    swiperContainer.appendChild(swiper);

    reviewsContainer.appendChild(swiperContainer);

    new Swiper(".review-swiper .swiper", {
      navigation: {
        nextEl: ".review-swiper .swiper-button-next",
        prevEl: ".review-swiper .swiper-button-prev",
      },
      pagination: {
        el: ".review-swiper .swiper-pagination",
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
    });
  } catch (error) {
    console.error("Loading ratings error:", error);
  }
}

// ! Newsletter
function addNewsletterBlock() {
  const newsletterEl = document.querySelector(".custom-footer__newsletter");
  if (newsletterEl) {
    const newsletterWrapper = document.createElement("section");
    newsletterWrapper.classList.add("newsletter-wrapper", "container");
    newsletterWrapper.appendChild(newsletterEl);

    footerGlobal.insertAdjacentElement("beforebegin", newsletterWrapper);

    const newsletterHeaderEl = newsletterEl.querySelector(".newsletter-header");
    const h4El = newsletterHeaderEl?.querySelector("h4");

    if (h4El) {
      if (typeof newsletterNadpis !== "undefined") {
        h4El.innerHTML = newsletterNadpis;
      }

      const headingWrapper = document.createElement("div");
      headingWrapper.classList.add("newsletter-heading");

      headingWrapper.appendChild(h4El);

      if (
        typeof newsletterNadpisImage !== "undefined" &&
        newsletterNadpisImage !== null
      ) {
        const newsletterImgEl = document.createElement("img");
        newsletterImgEl.src = newsletterNadpisImage;
        newsletterImgEl.alt = "Newsletter";
        headingWrapper.appendChild(newsletterImgEl);
      } else {
        console.log("newsletterNadpisImage is not defined or null");
      }

      newsletterHeaderEl.prepend(headingWrapper);
    } else {
      console.log("newsletterHeaderEl is not defined or null");
    }

    if (
      typeof newsletterText !== "undefined" &&
      newsletterText !== null &&
      h4El
    ) {
      const newsletterPerexEl = document.createElement("p");
      newsletterPerexEl.innerHTML = newsletterText;

      const headingWrapper = h4El.parentElement;
      headingWrapper?.after(newsletterPerexEl);
    } else {
      console.log("newsletterText is not defined or null");
    }

    if (typeof newsletterButton !== "undefined" && newsletterButton !== null) {
      const button = document.querySelector(".btn.btn-default.btn-arrow-right");
      button.querySelector("span.sr-only").textContent = newsletterButton;
    } else {
      console.log("newsletterButton is not defined or null");
    }
  }
}

function handleFavoriteCetegoryBanner() {
  const bannerNewborns = document.querySelector(".custom-footer__banner34 ");
  const bannerGirls = document.querySelector(".custom-footer__banner32 ");
  const bannerBoys = document.querySelector(".custom-footer__banner12 ");
  const bannerProductKings = document.querySelector(
    ".custom-footer__banner22 "
  );
  const bannerMomsDads = document.querySelector(".custom-footer__banner35 ");

  const goalContainer = document.createElement("div");
  goalContainer.classList.add("favorite-category-banner");
  const header = document.createElement("h4");
  header.classList.add("homepage-group-title");
  header.textContent = "Vaše oblíbené kategorie ";

  if (bannerNewborns) goalContainer.append(bannerNewborns);

  if (bannerGirls) goalContainer.append(bannerGirls);
  if (bannerBoys) goalContainer.append(bannerBoys);

  if (bannerProductKings) goalContainer.append(bannerProductKings);
  if (bannerMomsDads) goalContainer.append(bannerMomsDads);

  const sectionBrands = document.querySelector(".section-brands");
  if (sectionBrands) {
    sectionBrands.insertAdjacentElement("beforebegin", goalContainer);
  } else {
    console.error("Section brands not found");
  }
  goalContainer.insertAdjacentElement("beforebegin", header);
}

handleFavoriteCetegoryBanner();

function createFeedbackSection() {
  const reviewContainer = document.querySelector(".review-container.container");
  const newsletterWrapper = document.querySelector(
    ".newsletter-wrapper.container"
  );

  if (!reviewContainer && !newsletterWrapper) return;

  const feedbackSection = document.createElement("section");
  feedbackSection.className = "feedback-section container";

  if (reviewContainer) feedbackSection.appendChild(reviewContainer);
  if (newsletterWrapper) feedbackSection.appendChild(newsletterWrapper);

  const instagramWrapper = document.querySelector(".instagram-wrapper");
  if (instagramWrapper) {
    instagramWrapper.insertAdjacentElement("beforebegin", feedbackSection);
  } else {
    document.body.appendChild(feedbackSection);
  }
}

// Staňte se členem Kings Klubu! BANNER

function createKingsClubBanner() {
  const kingsClubBanner = document.querySelector(".custom-footer__banner11 ");
  const productsKingsBanner = document.querySelector(
    ".custom-footer__banner14 "
  );

  const goalContainerClub = document.querySelector(".custom-swiper-2");
  const goalContainerProducts = document.querySelector(".feedback-section");

  if (kingsClubBanner && goalContainerClub && isPageType(["homepage"])) {
    goalContainerClub.insertAdjacentElement("afterend", kingsClubBanner);
  } else {
    kingsClubBanner.remove();
  }

  if (
    // productsKingsBanner &&
    // goalContainerProducts &&
    isPageType(["category", "article"])
  ) {
    goalContainerProducts.insertAdjacentElement(
      "beforebegin",
      productsKingsBanner
    );
    productsKingsBanner.classList.add("container");
  } else {
    productsKingsBanner.remove();
  }

  if (isPageType("productDetail")) {
    productsKingsBanner.remove();
    kingsClubBanner.remove();
  }
}

function waitForElement(selector, timeout = 3000) {
  return new Promise((resolve) => {
    const intervalTime = 100;
    let timeElapsed = 0;

    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        resolve(element);
      } else if (timeElapsed >= timeout) {
        clearInterval(interval);
        resolve(null); // Продолжаем даже если элемент не найден
      }
      timeElapsed += intervalTime;
    }, intervalTime);
  });
}

function swiperProducts() {
  const productBlocks = document.querySelectorAll(".products-block");

  productBlocks.forEach((originalContainer, index) => {
    const productElements = Array.from(
      originalContainer.querySelectorAll(".product")
    );
    if (productElements.length <= 4) return;

    const swiperContainer = document.createElement("div");
    const swiperClass = `custom-swiper-${index}`;
    swiperContainer.className = `swiper-container ${swiperClass}`;

    const prevBtn = document.createElement("div");
    prevBtn.className = "swiper-button-prev";

    const nextBtn = document.createElement("div");
    nextBtn.className = "swiper-button-next";

    const swiper = document.createElement("div");
    swiper.className = "swiper";

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper", "products-block");

    productElements.forEach((product) => {
      product.classList.add("swiper-slide");
      wrapper.appendChild(product);
    });

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";

    swiper.appendChild(wrapper);
    swiper.appendChild(pagination);

    swiperContainer.appendChild(prevBtn);
    swiperContainer.appendChild(nextBtn);
    swiperContainer.appendChild(swiper);

    if (isPageType(["homepage"])) {
      const moreButton = document.createElement("a");
      moreButton.textContent = "Zobrazit vše";
      moreButton.classList.add("btn", "btn-secondary");
      if (swiperContainer.classList.contains("custom-swiper-0")) {
        moreButton.href = popularHref;
      } else if (swiperContainer.classList.contains("custom-swiper-1")) {
        moreButton.href = newHref;
      } else if (swiperContainer.classList.contains("custom-swiper-2")) {
        moreButton.href = saleHref;
      } else if (swiperContainer.classList.contains("custom-swiper-3")) {
        moreButton.href = kingsHref;
      } else {
        moreButton.href = "#";
      }

      swiperContainer.appendChild(moreButton);
    }

    originalContainer.parentNode.replaceChild(
      swiperContainer,
      originalContainer
    );

    new Swiper(`.${swiperClass} .swiper`, {
      loop: false,
      navigation: {
        nextEl: `.${swiperClass} .swiper-button-next`,
        prevEl: `.${swiperClass} .swiper-button-prev`,
      },
      pagination: {
        el: `.${swiperClass} .swiper-pagination`,
        clickable: true,
      },
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        0: { slidesPerView: 1.25, spaceBetween: 16 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      },
    });
  });
}

async function relatedProductsSwiper() {
  if (document.querySelector(".products-related-section")) return;
  const relatedHeader = document.querySelector("h2.products-related-header");
  const relatedProducts = relatedHeader?.nextElementSibling;

  const instagramWrapper = await waitForElement(".instagram-wrapper");

  if (relatedHeader && relatedProducts) {
    relatedHeader.textContent = "Také by se vám mohlo líbit";
    const section = document.createElement("section");
    section.classList.add("products-related-section");
    relatedProducts.classList.remove("p-switchable");

    relatedHeader.parentNode.insertBefore(section, relatedHeader);
    section.appendChild(relatedHeader);
    section.appendChild(relatedProducts);

    if (instagramWrapper) {
      instagramWrapper.insertAdjacentElement("beforebegin", section);
      section.classList.add("container");
    }
  }
}

function compactStarsWithRating() {
  const wrappers = document.querySelectorAll(".stars-wrapper");

  wrappers.forEach((wrapper) => {
    const rating = wrapper.getAttribute("data-micro-rating-value");
    const starList = wrapper.querySelector(".star-list");

    if (!rating || !starList) return;

    const stars = starList.querySelectorAll(".star");

    stars.forEach((star, index) => {
      if (index > 0) star.remove();
    });

    if (!wrapper.querySelector(".rating-number")) {
      const ratingSpan = document.createElement("span");
      ratingSpan.className = "rating-number";
      ratingSpan.textContent = `${rating} `;

      wrapper.insertBefore(ratingSpan, starList);
    }
  });
}
compactStarsWithRating();
document.addEventListener("ShoptetDOMContentLoaded", function () {
  compactStarsWithRating();
});
document.addEventListener("ShoptetPageSortingChanged", function () {
  compactStarsWithRating();
});

function handleAbouUsShops() {
  const banner = document.querySelector(".custom-footer__banner15");
  const goalBanner = document.querySelector(".custom-footer__banner14 ");

  console.log(banner, goalBanner);
  if (banner && goalBanner) {
    goalBanner.insertAdjacentElement("afterend", banner);
    banner.classList.add("container");
  }
}

function handleExpandableBlocks() {
  function applyExpandableBehavior({
    container,
    itemSelector,
    visibleCount,
    insertAfter,
  }) {
    const items = Array.from(container.querySelectorAll(itemSelector));
    if (items.length <= visibleCount) return;

    items.forEach((item, index) => {
      item.style.display = index < visibleCount ? "" : "none";
    });

    const button = document.createElement("button");
    button.textContent = "Zobrazit vše";

    button.addEventListener("click", () => {
      items.forEach((item) => (item.style.display = ""));
      button.remove();
    });

    insertAfter.parentNode.insertBefore(button, insertAfter.nextSibling);
  }

  document
    .querySelectorAll("#categories > .expandable.expanded > ul")
    .forEach((ul) => {
      applyExpandableBehavior({
        container: ul,
        itemSelector: ":scope > li",
        visibleCount: 7,
        insertAfter: ul,
      });
    });

  document.querySelectorAll(".filter-section").forEach((section) => {
    const fieldset = section.querySelector("form fieldset");
    if (!fieldset) return;

    const divs = Array.from(fieldset.querySelectorAll("div")).filter(
      (div) => !div.classList.contains("advanced-filters-wrapper")
    );
    if (divs.length <= 5) return;

    applyExpandableBehavior({
      container: fieldset,
      itemSelector: "div:not(.advanced-filters-wrapper)",
      visibleCount: 5,
      insertAfter: fieldset,
    });
  });

  document.querySelectorAll(".menu-level-3").forEach((ul) => {
    const items = Array.from(ul.querySelectorAll(":scope > li"));
    const visibleCount = 6;

    if (items.length <= visibleCount) return;

    items.forEach((item, index) => {
      item.style.display = index < visibleCount ? "" : "none";
    });

    const parentLink = ul
      .closest("li.has-third-level")
      ?.querySelector(":scope > div > a[href]");

    if (!parentLink) return;

    const button = document.createElement("a");
    button.className = "btn-more";
    button.textContent = "Zobrazit vše";

    button.addEventListener("click", () => {
      window.location.href = parentLink.href;
    });

    ul.parentNode.insertBefore(button, ul.nextSibling);
  });
}

handleExpandableBlocks();

function handleCategoryBanner(reload = false) {
  function moveCategoryBanners() {
    const categoryBanners = document.querySelectorAll(".banner-category");
    const firstProductBlock = document.querySelector("#products");
    const secondProductBlock = document.querySelector(
      ".products-block:not(#products)"
    );

    if (
      secondProductBlock &&
      (dataLayer?.[0]?.shoptet?.pageType !== "homepage" ||
        document.body.classList.contains("in-znacka"))
    ) {
      const secondBlockProducts =
        secondProductBlock.querySelectorAll(".product");
      for (let i = 0; i < secondBlockProducts.length; i++) {
        const product = secondBlockProducts[i];
        if (firstProductBlock) {
          firstProductBlock.appendChild(product);
        }
      }

      secondProductBlock.remove();
    }

    for (let index = 0; index < categoryBanners.length; index++) {
      const categoryBanner = categoryBanners[index];
      if (categoryBanner && firstProductBlock) {
        let whereToAppend = null;

        switch (index) {
          case 0:
            whereToAppend = firstProductBlock.querySelector(
              ".product:nth-child(6)"
            );
            break;
          case 1:
            whereToAppend = firstProductBlock.querySelector(
              ".product:nth-child(13)"
            );
            break;
        }

        if (whereToAppend) {
          whereToAppend.after(categoryBanner);
        }
      }
    }
  }
  moveCategoryBanners();

  function handleUpBtn() {
    const upBtn = document.querySelector(".pagination-top");
    if (upBtn) {
      upBtn.classList.add("btn", "btn-secondary");
    }
    const textBtn = upBtn?.querySelector("strong.js-scroll-top");
    if (textBtn) {
      textBtn.textContent = "Zpět nahoru";
    }
  }
  handleUpBtn();

  function handlePaginationWrapper() {
    const paginationWrapper = document.querySelector(".pagination-wrapper");
    if (paginationWrapper) {
      const paginationContent = paginationWrapper.innerHTML.trim();
      if (paginationContent === "") {
        paginationWrapper.style.display = "none";
      }
    }
  }
  handlePaginationWrapper();
}

const activeListeners = [];
const handleFilterEvents = () => {
  const filterSections = document.querySelectorAll(
    "#category-filter-hover .filter-section:not(.filter-section-count)"
  );

  document.querySelectorAll(".expanded").forEach((element) => {
    element.classList.remove("expanded");
  });

  if (filterSections.length) {
    filterSections.forEach((section) => {
      let heading = section.querySelector("h4");
      if (heading && !activeListeners.includes(heading)) {
        activeListeners.push(heading);
        heading.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          section.classList.toggle("filter-form-visible");
          let cache =
              JSON.parse(window.sessionStorage.getItem("openedFilters")) || [],
            parentClass = e.currentTarget.parentElement.className;
          parentClass = parentClass.replace("filter-form-visible", "");
          parentClass = parentClass.trim();
          if (cache.includes(parentClass)) {
            cache = cache.filter((item) => {
              return item !== parentClass;
            });
          } else {
            cache.push(parentClass);
          }
          window.sessionStorage.setItem("openedFilters", JSON.stringify(cache));
        });
      }
    });
  }

  let helperCache = window.sessionStorage.getItem("openedFilters");
  if (helperCache) {
    helperCache = JSON.parse(helperCache);
    if (helperCache.length) {
      helperCache.forEach((item) => {
        item = item.replaceAll(" ", ".");
        item = document.querySelector(`.${item}`);
        if (item) item.classList.add("filter-form-visible");
      });
    }
  }
};
if (
  dataLayer[0].shoptet.pageType === "category" ||
  dataLayer[0].shoptet.pageType === "parametricCategory"
) {
  handleFilterEvents();
  document.addEventListener("ShoptetDOMContentLoaded", handleFilterEvents);
}

function moveElement(sourceSelector, targetElement) {
  const sourceElement = document.querySelector(sourceSelector);
  if (sourceElement) {
    sourceElement.classList.remove("tab-pane", "fade");
    targetElement.insertAdjacentElement("afterend", sourceElement);
  }
}

function updateHeading(selector, text) {
  const heading = document.querySelector(selector);
  if (heading) heading.textContent = text;
}

function handleProductDetailedDescription() {
  const extendedProductDescription = document.querySelector(
    ".extended-description"
  );

  const description = document.querySelector("#description");
  extendedProductDescription
    ?.querySelector("h3")
    .setAttribute("id", "parameters");
  moveElement("#productDiscussion", description);

  moveElement("#ratingTab", description);

  updateHeading(".basic-description h3", "Popis produktu");
  updateHeading(".extended-description h3", "Parametry");

  const ratingTab = document.querySelector("#ratingTab");

  if (ratingTab) {
    const newHeading = document.createElement("h3");
    newHeading.textContent = "Hodnocení";
    ratingTab.prepend(newHeading);
    ratingTab.classList.add("tab-pane");
    const rateAverage = document.querySelector(
      '[data-testid="textRatingAverage"]'
    );
    if (rateAverage && !rateAverage.innerHTML.includes("z 5")) {
      rateAverage.innerHTML += ' <span class="rate-max">z 5</span>';
    }

    const addCommentBtn = document.querySelector("#ratingTab .add-comment");
    if (addCommentBtn) {
      ratingTab.insertAdjacentElement("beforeend", addCommentBtn);
    }
    // const btn = document.querySelector(".btn.btn-primary.js-load-ratings");
    // if (btn) btn.textContent = "Přečíst všechny hodnocení";
  }
  const productDiscussion = document.querySelector("#productDiscussion");
  if (productDiscussion) {
    const newHeading = document.createElement("h3");
    newHeading.textContent = "Diskuze";
    productDiscussion.prepend(newHeading);
    productDiscussion.classList.add("tab-pane");

    const addCommentBtn = document.querySelector(
      "#productDiscussion .add-comment"
    );
    if (addCommentBtn) {
      productDiscussion.insertAdjacentElement("beforeend", addCommentBtn);
    }

    productDiscussion
      .querySelectorAll('[data-testid="textComment"]')
      .forEach((comment) => {
        const voteWrap = comment.closest(".vote-wrap");
        const voteHeader = voteWrap.querySelector(".vote-header");

        if (voteHeader) {
          comment.parentNode.insertBefore(voteHeader, comment.nextSibling);
        }
      });

    // const containerBtn = document.createElement("div");
    // containerBtn.className = "container-btn";
    // const btn = document.querySelector(".btn.btn-primary.js-load-discussions");
    // if (btn) btn.textContent = "Přečíst všechno";

    // const addDiscussionBtn = document.querySelector(
    //   ".add-comment.discussion-form-trigger"
    // );
    // if (addDiscussionBtn && btn) {
    //   containerBtn.append(btn, addDiscussionBtn);
    //   productDiscussion.appendChild(containerBtn);
    // }

    // document.addEventListener("ShoptetDOMProductDiscussionsLoaded", () => {
    //   btn.style.display = "none";
    // });
  }

  extendedProductDescription?.classList.add("tab-pane");
  const basicDescription = document.querySelector(".basic-description");
  if (basicDescription) {
    basicDescription.classList.add("tab-pane", "active");
  }

  description.classList.remove("tab-pane");
  const tabPanes = document.querySelectorAll(".tab-pane");
  if (tabPanes.length) {
    tabPanes.forEach((pane) => {
      pane.classList.remove("fade");
      pane.removeAttribute("role");
      const heading = pane.querySelector("h3");
      if (heading) {
        heading.addEventListener("click", () => {
          pane.classList.toggle("active");
        });
      }
    });
  }
}

function handleFooter() {
  function handleFooterMenuMobile() {
    const siteName = document.querySelector("#footer .site-name");
    const menu = document.querySelector(".custom-footer");

    if (siteName && menu) {
      if (window.innerWidth < 960) {
        const logo = siteName.querySelector('[data-testid="linkWebsiteLogo"]');
        logo.insertAdjacentElement("afterend", menu);
      } else {
        siteName.insertAdjacentElement("afterend", menu);
      }
    }
  }

  handleFooterMenuMobile();
  window.addEventListener("resize", handleFooterMenuMobile);
}

handleFooter();
document.addEventListener("ShoptetDOMContentLoaded", () => {
  handleFooter();
});

// ! CART PAGE

function handleCartProducts() {
  const rows = document.querySelectorAll(".removeable");

  rows.forEach((row) => {
    const priceCell = row.querySelector(".p-price.p-cell");
    const totalCell = row.querySelector(".p-total");

    if (priceCell && totalCell) {
      totalCell.appendChild(priceCell);
      priceCell.classList.add("moved-price");
    }

    const related = row.querySelector(".show-related");
    const deleteForm = row.querySelector(".p-total form");

    if (deleteForm) {
      const relatedContainer = document.createElement("div");
      relatedContainer.className = "related-delete";
      if (related) relatedContainer.appendChild(related);
      relatedContainer.appendChild(deleteForm);

      row.appendChild(relatedContainer);
    }
  });
}

function createCartFooter() {
  if (document.querySelector(".ordering-process-footer")) {
    return;
  }
  const footer = document.createElement("footer");
  footer.classList.add("ordering-process-footer");

  const container = document.createElement("div");
  container.classList.add("container");
  footer.appendChild(container);

  const cartHelp = document.createElement("div");
  cartHelp.classList.add("cart-content", "checkout-box-wrapper");
  cartHelp.innerHTML = `
      <h4>Potřebujete pomoc?<p class="after-text">Lorem ipsum dolor sit amet adpisicng lorem ipsum dolor sit amet</p></h4>
      <div class="box box-sm box-bg-default">
        <div class="contact-box no-image" data-testid="contactbox">
          <ul>
            <li>
              <span class="mail" itemprop="email" data-testid="contactboxEmail">
                <a href="mailto:kings.cz@email.cz">kings.cz@email.cz</a>
              </span>
            </li>
            <li>
              <span class="tel" itemprop="telephone" data-testid="contactboxPhone">
                <a href="tel:+420736226421" aria-label="Zavolat na +420736226421">
                  +420 736 226 421
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    `;
  const footerText = document.createElement("div");
  footerText.classList.add("secure-payment");
  footerText.innerHTML = `
            <span>Bezpečná platba</span>
            <img src="/user/documents/upload/miranda/stack.svg" alt="Secure payment" />
          `;
  container.appendChild(footerText);
  container.appendChild(cartHelp);
  return footer;
}

function handleCart() {
  const overallWrapper = document.querySelector(".overall-wrapper");
  if (!overallWrapper) return;

  if (document.querySelector(".ordering-process-footer")) return;

  const footer = createCartFooter();
  if (!footer) return;

  addContactInfo(footer);
  overallWrapper.appendChild(footer);
}

if (isPageType(["homepage", "category", "article", "section"])) {
  waitForInstagramBtn(async (btn) => {
    addInstagramBlock(btn);
    await handleReviews();
    addNewsletterBlock();
    createFeedbackSection();
    createKingsClubBanner();
    if (document.body.classList.contains("in-o-nas-historie")) {
      handleAbouUsShops();
    }
  });
}

if (isPageType(["productDetail"])) {
  waitForInstagramBtn(async (btn) => {
    addInstagramBlock(btn);

    createKingsClubBanner();
  });
}

// if (!isPageType(["cart", "billingAndShipping", "customerDetails"]))
if (isPageType(["homepage", "productDetail"])) swiperProducts();
if (isPageType(["productDetail"])) {
  relatedProductsSwiper();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    relatedProductsSwiper();
  });
}
if (isPageType(["category"]) || document.body.classList.contains("in-znacka")) {
  handleCategoryBanner();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    handleCategoryBanner(true);
  });
}

if (isPageType(["productDetail"])) handleProductDetailedDescription();

if (isPageType(["cart", "billingAndShipping", "customerDetails"])) {
  handleCartProducts();
  handleCart();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    handleCartProducts(true);
    handleCart();
  });
}
if (isPageType(["homepage", "article", "category"])) {
  waitForInstagramBtn((btn) => {
    addInstagramBlock(btn);
  });

  document.addEventListener("ShoptetDOMPageContentLoaded", () => {
    waitForInstagramBtn((btn) => {
      addInstagramBlock(btn);
    });
  });
}

const flagsHandler = (product) => {
  const priceStandardFlag = product.querySelector(".price-standard");
  const pricesEl = product.querySelector(".prices");
  if (priceStandardFlag) {
    pricesEl.prepend(priceStandardFlag);
  }
  const flagsDefault = product.querySelector(".flags-default");
  const flagsExtra = product.querySelector(".flags-extra");

  if (flagsDefault && flagsExtra) {
    flagsDefault.append(flagsExtra);
    flagsExtra.classList.add("in-default-flags");
  }

  const flagCode = product.querySelector("span.p-code");
  const imageLink = product.querySelector("a.image");
  if (flagCode) imageLink.append(flagCode);
  const flagBio = product.querySelector(".flag-bio-produkt");
  if (flagBio && window.innerWidth > 767) {
    imageLink.append(flagBio);
  }
};

const productHandler = () => {
  const productCards = document.querySelectorAll(
    ".products-block div[data-micro='product']"
  );
  if (productCards.length) {
    productCards.forEach((product) => {
      flagsHandler(product);
      document.addEventListener(
        "ShoptetDOMContentLoaded",
        flagsHandler(product)
      );
    });
  }
};
productHandler();
document.addEventListener("ShoptetDOMContentLoaded", productHandler);
